export enum ZakekeEnvironment {
    Customizer = 1,
    Composer = 2,
    Viewer = 3,
    AIStudio = 4
}

export enum ProductStatus {
    Published = 1,
    UnPublished = 2
}

export enum EcommerceId {
    NONE = -1,
    MAGENTO2 = 1,
    WOOCOMMERCE = 2,
    SHOPIFY = 3,
    OPENCART = 4,
    MAGENTO1 = 5,
    PRESTASHOP = 6,
    API = 7,
    BIGCOMMERCE = 9,
    CCLOUD = 11,
    ETSY = 12,
    WIX = 13,
    SHOPWARE = 14
}

export enum PaletteType {
    None = 0,
    Pantone = 1,
    CMYK = 2
}
